import styled from "styled-components";

export const SearchFormResultsWrapperCasino777Box = styled.div`
    background: ${props => props.theme.colors.brandSecondary};
    padding: 1rem;
`;